/** Typed API failure — branch on `code`, show `msg`. */

export class ApiError extends Error {
  readonly code: string;
  readonly status: number;

  constructor(input: { code: string; msg: string; status: number }) {
    super(input.msg);
    this.name = "ApiError";
    this.code = input.code;
    this.status = input.status;
  }
}

export function isApiError(err: unknown): err is ApiError {
  return err instanceof ApiError;
}

export function apiErrorCode(err: unknown): string | null {
  return isApiError(err) ? err.code : null;
}
